export default __webpack_public_path__ + "app/images/2b0f28822c68860d6f852e333078bd48.svg";